<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Trip details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="updateTrip">
          <b-row>
            <b-col lg="8">
              <b-col lg="12">
                <div class="form-group">
                  <label class="form-control-label" for="name">Name</label>
                  <input type="text" class="form-control" id="name" placeholder="Name" v-model="model.name">
                </div>
              </b-col>
              <b-col lg="12">
                <div class="form-group">
                  <label class="form-control-label" for="description">Description</label>
                  <b-form-textarea rows="4" v-model="model.description" id="description" placeholder="Description"></b-form-textarea>
                  <!-- <input type="text" class="form-control" id="description" placeholder="Description" v-model="model.description"> -->
                </div>
              </b-col>
            </b-col>
            <b-col lg="4">
              <b-col lg="12">
                <div class="form-group">
                  <label class="form-control-label" for="startKm">Motorbike km on start</label>
                  <input type="number" class="form-control" id="startKm" placeholder="Motorbike km on start" v-model.number="model.startKm">
                </div>
              </b-col>
              <b-col lg="12">
                <div class="form-group">
                  <label class="form-control-label" for="endKm">Motorbike km on finish</label>
                  <input type="number" class="form-control" id="endKm" placeholder="Motorbike km on finish" v-model.number="model.endKm">
                </div>
              </b-col>
            </b-col>
          <!-- </b-row>
          <b-row> -->
            <b-col cols="12">
              <hr class="my-3">
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="startDate">Start date</label>
                <base-input type="date" id="startDate" placeholder="Start date" v-model="model._startDate" :max="model._endDate" @change="startDateChanged"/>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="endDate">Finish date</label>
                <base-input type="date" id="endDate" placeholder="Finish date" v-model="model._endDate" :min="model._startDate" @change="endDateChanged"/>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="motorbike">Motorbike</label>
                <select class="form-control" v-model="model.motorbike">
                  <option v-bind:value="null">- Empty -</option>
                  <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
                </select>
              </div>
            </b-col>
            <b-col cols="12" v-if="!showMap">
              <base-alert type="secondary">
                <template v-slot:icon>
                  <b-icon-info-circle></b-icon-info-circle>
                </template>
                Fill start date, finish date and motorbike to show tracks in that dates.</base-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="card mb-4" v-if="showMap">
                <toosho-map
                  ref="map"
                  :from-date="computedFilters.startDate"
                  :to-date="computedFilters.endDate"
                  :motorbike="computedFilters.motorbike"
                  :ids-to-show="computedFilters.tracks"
                  @shownTracksChanged="(ids) => this.model.tracks = ids">
                </toosho-map>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import TooshoMap from '../../components/TooshoMap.vue'
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'device-page',
    components: {
      RouteBreadCrumb,
      TooshoMap
    },
    data() {
      return {
        model: {}
      };
    },
    async mounted() {
      await this.listMotorbikes()
    },
    methods: {
      ...mapActions({
        listMotorbikes: 'motorbikes/fetch',
        editTrip: 'trips/edit'
      }),
      async updateTrip() {
        await this.editTrip({ id: this.$route.params.id, data: this.model })
        this.$router.push({ name: 'trip', params: {id: this.trip._id}})
      },
      startDateChanged() {
        this.model.startDate = this.model._startDate && this.model._startDate.fromInputDateFormatToDate().toISOString()
      },
      endDateChanged() {
        this.model.endDate = this.model._endDate && this.model._endDate.fromInputDateFormatToDate().toISOString()
      }
    },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes',
        trip: 'trips/item'
      }),
      hasChanges () {
        let changes = 0
        const keys = [
          'name',
          'description',
          'startDate',
          'endDate',
          'motorbike',
          'startKm',
          'endKm',
          'tracks'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if (this.model[key]) {
            changes++
          }
        })
        return !!(changes)
      },
      computedFilters() {
        return {
          startDate: this.model._startDate && this.model._startDate.fromInputDateFormatToDate(),
          endDate: this.model._endDate && this.model._endDate.fromInputDateFormatToDate(),
          motorbike: this.model.motorbike,
          tracks: this.model.tracks && this.model.tracks.map(track => track._id || track)
        }
      },
      showMap() {
        return this.computedFilters.startDate && this.computedFilters.endDate && this.computedFilters.motorbike
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
